import React, { useEffect, useState } from "react";
import { Sparkles, Download } from "lucide-react";
import { adminSpins, API } from "@/lib/api";

export const AdminSpins = ({ token }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => token && adminSpins(token).then(setData).catch(() => {});
    load();
    window.addEventListener("admin-refresh", load);
    return () => window.removeEventListener("admin-refresh", load);
  }, [token]);

  return (
    <div className="bg-white border-4 border-black rounded-2xl p-4 sm:p-6 shadow-brutal mb-8" data-testid="admin-spins">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <Sparkles className="h-6 w-6 text-candy-pink" />
        <h2 className="font-display text-3xl">Spin to Win</h2>
        <span className="font-mono text-xs font-bold uppercase" data-testid="admin-spins-summary">
          {data ? `${data.total} played · ${data.winners} won · ${data.redeemed} redeemed` : "Loading…"}
        </span>
        <a
          href={`${API}/admin/spins/export?token=${encodeURIComponent(token)}`}
          data-testid="admin-spins-export-btn"
          className="ml-auto inline-flex items-center gap-2 bg-candy-teal text-white font-bold uppercase text-xs tracking-wider py-2.5 px-4 border-4 border-black rounded-xl"
        >
          <Download className="h-4 w-4" /> Download Emails (Spreadsheet)
        </a>
      </div>
      <div className="overflow-x-auto max-h-96">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-xs uppercase border-b-2 border-black">
              <th className="py-2 pr-3">Date</th><th className="pr-3">Name</th><th className="pr-3">Email</th>
              <th className="pr-3">Spins</th><th className="pr-3">Result</th><th className="pr-3">Code</th><th>Status</th>
            </tr>
          </thead>
          <tbody>
            {(data?.entries || []).map((e) => (
              <tr key={e.id} className="border-b border-black/10" data-testid={`admin-spin-row-${e.id}`}>
                <td className="py-2 pr-3 whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                <td className="pr-3">{e.name}</td>
                <td className="pr-3">{e.email}</td>
                <td className="pr-3">{e.spins_used ?? 1}/3</td>
                <td className={`pr-3 font-bold ${e.won ? "text-green-700" : "text-black/50"}`}>{e.prize_label}</td>
                <td className="pr-3 font-mono">{e.code || "—"}</td>
                <td className="whitespace-nowrap">{e.won ? (e.redeemed ? "Redeemed" : "Not used yet") : "—"}</td>
              </tr>
            ))}
            {data && data.entries.length === 0 && (
              <tr><td colSpan={7} className="py-4 text-center text-black/50">No spins yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
